import React from "react";
import { Box } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useDumontPanel } from "../../../context/DumontPanelContext";
import { PRIVATE_ROUTES } from "../../../constants";
import DumontSidebar from "../../../components/DumontSidebar";
import { DumontAuthGate } from "../../../components/DumontSidebar/DumontAuthGate";

/**
 * Full-page Ask Dumont view. Renders the Dumont API-backed sidebar in embedded mode
 * so it fills the viewport. Close navigates back.
 */
export default function DumontSidebarPage() {
  const history = useHistory();
  const { openPanel } = useDumontPanel();

  const handleExitToSideTab = () => {
    // Navigate back to main dashboard and reopen Dumont side tab
    history.push(PRIVATE_ROUTES.OVERVIEW);
    openPanel();
  };

  return (
    <Box sx={{ height: "calc(100vh - 124px)", width: "100%", display: "flex" }}>
      <DumontAuthGate>
        <DumontSidebar
          isOpen={true}
          onClose={() => history.goBack()}
          embedded
          startFullscreen
          onExitFullscreenToTab={handleExitToSideTab}
        />
      </DumontAuthGate>
    </Box>
  );
}